document.addEventListener("DOMContentLoaded", () => {

  /* ============================================================
     GIFT CARD LIMIT CHECK
  ============================================================ */
  function checkGiftCardLimit() {
    const giftCardBtn = document.getElementById("add-gift-card");
    if (!giftCardBtn) return;

    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        let count = 0;

        cart.items.forEach(item => {
          const pt = (item.product_type || "").toLowerCase();
          const handle = item.handle || "";

          if (pt.includes("gift card") || handle.includes("gift-card")) {
            count += item.quantity;
          }
        });

        if (count >= 2) {
          giftCardBtn.disabled = true;
          giftCardBtn.classList.add("disabled");
          giftCardBtn.innerHTML = "<span>Gift card limit reached (2)</span>";
        } else {
          giftCardBtn.disabled = false;
          giftCardBtn.classList.remove("disabled");
          giftCardBtn.innerHTML = "<span>Add a Gift Card on us</span>";
        }
      });
  }

  /* ============================================================
     GIFT CARD BUTTONS + MODAL
  ============================================================ */
  function bindGiftCardBtns() {
    const giftCardBtn = document.getElementById("add-gift-card");
    const giftCardModal = document.getElementById("gift-card-modal");
    const closeGiftCard = document.getElementById("close-gift-card");
    const saveGiftCard = document.getElementById("save-gift-card");
    const giftWrapBlock = document.getElementById("gift-wrap-block");

    const zoomModal = document.getElementById("gift-card-modal-drawer");
    const zoomImg = document.getElementById("gift-card-drawer-img");
    const zoomClose = document.getElementById("gift-card-drawer-close");

    if (!giftCardBtn) return;

    // Zoom image
    document.querySelectorAll(".gift-card-drawer-zoom").forEach(btn => {
      btn.addEventListener("click", () => {
        const src = btn.getAttribute("data-image");
        if (src) {
          zoomImg.src = src;
          zoomModal.classList.add("is-active");
        }
      });
    });

    zoomClose?.addEventListener("click", () => {
      zoomModal.classList.remove("is-active");
      zoomImg.src = "";
    });

    zoomModal?.addEventListener("click", (e) => {
      const content = zoomModal.querySelector(".gift-card-drawer-content");
      if (content && !content.contains(e.target)) {
        zoomModal.classList.remove("is-active");
        zoomImg.src = "";
      }
    });

    // Open modal
    giftCardBtn.addEventListener("click", () => {
      if (giftCardBtn.disabled) return;
      giftCardModal.style.display = "block";
      giftWrapBlock?.classList.add("is-hidden");
    });

    // Close modal
    closeGiftCard?.addEventListener("click", () => {
      giftCardModal.style.display = "none";
      giftWrapBlock?.classList.remove("is-hidden");
    });

    // Save gift card
    saveGiftCard?.addEventListener("click", () => {
      const variant = document.querySelector('input[name="gift-card-variant"]:checked');
      const msg = document.querySelector('textarea[name="attributes[Message]"]').value;

      if (!variant) {
        alert("Please select a gift card design.");
        return;
      }

      let props = {};
      if (msg) props["Message"] = msg;

      fetch("/cart.js")
        .then(res => res.json())
        .then(cart => {
          let count = 0;
          cart.items.forEach(item => {
            if (
              (item.product_type || "").toLowerCase().includes("gift card") ||
              (item.handle || "").includes("gift-card")
            ) {
              count += item.quantity;
            }
          });

          if (count >= 2) {
            alert("You can only add up to 2 gift cards.");
            checkGiftCardLimit();
            return;
          }

          addToCart([{ id: variant.value, quantity: 1, properties: props }]).then(() => {
            giftCardModal.style.display = "none";
            giftWrapBlock?.classList.remove("is-hidden");
            checkGiftCardLimit();
          });
        });
    });

    checkGiftCardLimit();
  }

  /* ============================================================
     GIFT WRAP BUTTON
  ============================================================ */
  function bindGiftWrapBtn() {
    const btn = document.getElementById("gift-wrap-btn");
    if (!btn) return;

    // Remove existing handler
    if (btn._handler) btn.removeEventListener("click", btn._handler);

    btn._handler = async () => {
      const variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;

      const active = btn.classList.contains("active");
      btn.classList.add("loading");

      try {
        if (active) {
          await updateGiftWrap(variantId, "remove");
          btn.classList.remove("active");
        } else {
          await updateGiftWrap(variantId, "add");
          btn.classList.add("active");
        }
      } catch (err) {
        console.error(err);
      } finally {
        btn.classList.remove("loading");
      }
    };

    btn.addEventListener("click", btn._handler);

    checkGiftWrapInCart(btn);
  }

  function updateGiftWrap(variantId, action) {
    const data =
      action === "add"
        ? { items: [{ id: variantId, quantity: 1 }] }
        : { updates: { [variantId]: 0 } };

    const url = action === "add" ? "/cart/add.js" : "/cart/update.js";

    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then(r => r.json())
      .then(() => refreshCartDrawerUI());
  }

  function checkGiftWrapInCart(btn) {
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const id = btn.getAttribute("data-variant-id");
        const exists = cart.items.some(item => item.variant_id == id);
        btn.classList.toggle("active", exists);
      });
  }

  /* ============================================================
     ADD TO CART
  ============================================================ */
  function addToCart(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    }).then(() => refreshCartDrawerUI());
  }

  /* ============================================================
     REFRESH CART DRAWER + REBIND FEATURES
  ============================================================ */
  function refreshCartDrawerUI() {
    return fetch("/?sections=cart-drawer,cart-icon-bubble")
      .then(r => r.json())
      .then(sections => {
        const parser = new DOMParser();

        // Drawer content
        const drawer = document.querySelector("#CartDrawer-CartItems");
        if (drawer && sections["cart-drawer"]) {
          const newDoc = parser.parseFromString(sections["cart-drawer"], "text/html");
          const newItems = newDoc.querySelector("#CartDrawer-CartItems");
          if (newItems) drawer.innerHTML = newItems.innerHTML;
        }

        // Icon bubble
        const bubble = document.querySelector("#cart-icon-bubble");
        if (bubble && sections["cart-icon-bubble"]) {
          bubble.innerHTML = sections["cart-icon-bubble"];
        }

        // Rebind everything
        bindGiftWrapBtn();
        bindGiftCardBtns();
        bindCartRemoveButtons();
        checkGiftCardLimit();
      });
  }

  function bindCartRemoveButtons() {
    document.querySelectorAll(".cart-remove-button").forEach(btn => {
      btn.addEventListener("click", () => {
        setTimeout(() => checkGiftCardLimit(), 300);
      });
    });
  }

  /* ============================================================
     EXPOSE GLOBAL REBIND FUNCTION
  ============================================================ */
  window.rebindGiftFeatures = () => {
    bindGiftWrapBtn();
    bindGiftCardBtns();
    bindCartRemoveButtons();
    checkGiftCardLimit();
  };

  /* ============================================================
     INITIAL RUN
  ============================================================ */
  bindGiftWrapBtn();
  bindGiftCardBtns();
  bindCartRemoveButtons();
  checkGiftCardLimit();
});
